import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { WarningIcon } from '@phosphor-icons/react';

export function RouteErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Something went wrong';

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 3,
        py: 6,
        textAlign: 'center',
      }}
    >
      <WarningIcon size={48} weight="light" color="#D85A30" />
      <Typography variant="h5" fontWeight={500}>
        Something went wrong
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        {message}
      </Typography>
      <Button variant="contained" onClick={() => window.location.reload()} sx={{ mt: 2 }}>
        Reload page
      </Button>
    </Box>
  );
}
